class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onArticleNumberSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  // 2026-10-20: Shopify sucht nur Wortanfaenge, "2542/001" findet "0002542/001/040/001" nicht.
  // Artikelnummern sind 7-stellig mit fuehrenden Nullen. Die reine Kurzform ("2542") deckt ein
  // Produkt-Tag ab (shopify-suche/artikelnummer_tags.py); hier wird aufgefuellt, wenn ein Zusatz
  // folgt ("2542/001", "2542 001") oder schon Nullen getippt wurden ("02542").
  static normalizeArticleNumber(query) {
    const match = query.trim().match(/^(\d{4,6})([\s\/-].*)?$/);
    if (!match) return query;
    const [, digits, rest = ''] = match;
    if (!rest && !digits.startsWith('0')) return query;
    return digits.padStart(7, '0') + rest;
  }

  onArticleNumberSubmit() {
    const normalized = SearchForm.normalizeArticleNumber(this.input.value);
    if (normalized !== this.input.value) this.input.value = normalized;
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
